<template>
  <div class="single-code-analysis-page">
    <div class="single-code-analysis-top">

      <div class="single-code-analysis-top-search">
        <el-row :gutter="30">
          <el-col :span="4">
            <span>{{$t('SingleCodeAnalysis.t01')}}</span>
            <el-select v-model="searchcodeid" placeholder="请选择" size="small" popper-class="singlecodetopselect" @change="changeCode(searchcodeid)">
              <el-option v-for="item in searchcodeidoptions" :key="item.value" :label="item.value" :value="item.value"></el-option>
            </el-select>          
          </el-col>
          <el-col :span="4">
            <span>{{$t('SingleCodeAnalysis.t02')}}</span>
            <el-select v-model="searchflow" placeholder="请选择" size="small" popper-class="singlecodetopselect">
              <el-option v-for="item in searchflowoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>          
          </el-col>
          <el-col :span="4">
            <span>{{$t('SingleCodeAnalysis.t03')}}</span>
            <el-select v-model="searchindex" placeholder="请选择" size="small" popper-class="singlecodetopselect">
              <el-option v-for="item in searchindexoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>          
          </el-col>
          <el-col :span="4">
            <span>{{$t('SingleCodeAnalysis.t04')}}</span>
            <el-select v-model="searchunit" placeholder="请选择" size="small" v-if="searchindex==='volume'" popper-class="singlecodetopselect">
              <el-option v-for="item in searchunitoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="searchunit2" placeholder="请选择" size="small" v-if="searchindex==='value'" popper-class="singlecodetopselect">
              <el-option v-for="item in searchunitoptions2" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span>{{$t('SingleCodeAnalysis.t05')}}</span>
            <el-date-picker
              :clearable="false"
              class="searchperiod"
              size="small"
              v-model="searchperiod"
              type="month"
              :picker-options="pickerOptions"
              popper-class="selectmonth"
              placeholder="选择月"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>          
          </el-col>
          <el-col :span="4">
            <div class="single-code-analysis-top-search-confirm">
              <el-button class="homeokbtn" type="primary" @click="confirmSelect()">OK</el-button>
            </div>
          </el-col>
        </el-row>
      </div><!--single-code-analysis-top-search-->

      <div class="single-code-analysis-top-result">
        <el-row :gutter="30">
          <el-col :span="5">
            <div class="single-code-analysis-top-result-col">
              <span><el-button :class="activebtn1" type="text" size="mini" :disabled="filedbtndisabled" @click="onLastcount()">{{ resultlineperiod }}</el-button></span>
              <el-row>
                <el-col :span="16">
                  <div class="scatrc-left">
                    <h2>{{ tabdata.lastcount }}</h2>
                    <h3>{{$t('SingleCodeAnalysis.t09')}}</h3>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="scatrc-right">
                    <h2>{{ tabdata.lastunit }}</h2>
                    <h3>{{ tabdata.lastpercent }}</h3>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="single-code-analysis-top-result-col">
              <span><el-button :class="activebtn2" type="text" size="mini" :disabled="filedbtndisabled" @click="onLast3Monthsount()">{{ resultlinelatest3months }}</el-button></span>
              <el-row>
                <el-col :span="16">
                  <div class="scatrc-left">
                    <h2>{{ tabdata.last3monthscount }}</h2>
                    <h3>{{$t('SingleCodeAnalysis.t09')}}</h3>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="scatrc-right">
                    <h2>{{ tabdata.last3monthsunit }}</h2>
                    <h3>{{ tabdata.last3monthspercent }}</h3>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="single-code-analysis-top-result-col">
              <span><el-button :class="activebtn3" type="text" size="mini" :disabled="filedbtndisabled" @click="onYtdcount()">{{ resultlineytd }}</el-button></span>
              <el-row>
                <el-col :span="16">
                  <div class="scatrc-left">
                    <h2>{{ tabdata.ytdcount }}</h2>
                    <h3>{{$t('SingleCodeAnalysis.t09')}}</h3>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="scatrc-right">
                    <h2>{{ tabdata.ytdunit }}</h2>
                    <h3>{{ tabdata.ytdpercent }}</h3>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="single-code-analysis-top-result-col">
              <span><el-button :class="activebtn4" type="text" size="mini" :disabled="filedbtndisabled" @click="onMatcount()">{{ resultlinemat }}</el-button></span>
              <el-row>
                <el-col :span="16">
                  <div class="scatrc-left">
                    <h2>{{ tabdata.matcount }}</h2>
                    <h3>{{$t('SingleCodeAnalysis.t09')}}</h3>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="scatrc-right">
                    <h2>{{ tabdata.matunit }}</h2>
                    <h3>{{ tabdata.matpercent }}</h3>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div><!--single-code-analysis-top-result-->

      <div class="single-code-analysis-title">
        <h1 :title="currentcodelabel">{{ currentcodelabel}}</h1>
      </div>

    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 0">
      <h2>{{ charttitle1 }}</h2>
      <BarChart
        v-if="hasdatachart1"
        chartid="trendid"
        charttitle="Import Volume Trend" 
        :chartdata="linechartdata"
      />
      <ChartNoData v-if="!hasdatachart1" />
    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 1">
      <h2>{{ charttitle2 }}</h2>
      <el-row :gutter="0" v-if="hasdatachart2">
        <el-col :span="20">
          <TreemapChart 
            chartid="countrysharechartid"
            charttitle="Import Volume Trend" 
            :tooltip1="tooltip1"
            :tooltip2="tooltip3"
            :tooltip3="tooltip99"
            :chartdata="countrysharechartdata"
          />
        </el-col>
        <el-col :span="4">
          <ul class="chartcolortxt">
            <li><span class="color-europe"></span>{{ $t('charttxt.z4') }}</li>
            <li><span class="color-north-america"></span>{{ $t('charttxt.z3') }}</li>
            <li :title="$t('charttxt.z7')"><span class="color-latin-america-caribbean"></span>{{ $t('charttxt.z7') }}</li>
            <li><span class="color-oceania"></span>{{ $t('charttxt.z5') }}</li>
            <li><span class="color-asia"></span>{{ $t('charttxt.z2') }}</li>
            <li><span class="color-africa"></span>{{ $t('charttxt.z1') }}</li>
            <li><span class="color-others"></span>{{ $t('charttxt.z6') }}</li>
          </ul>
        </el-col>
      </el-row>
      <ChartNoData v-if="!hasdatachart2" />
    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 2">
      <h2>{{ charttitle3 }}</h2>
      <el-row :gutter="0" v-if="hasdatachart3">
        <el-col :span="20">
          <ScatterChart 
            chartid="countryshareyoychartid"
            charttitle="Import Volume Trend" 
            :xtitle="xtitle"
            :ytitle="ytitle"
            :tooltip1="tooltip1"
            :tooltip2="tooltip2"
            :tooltip3="tooltip3"
            :chartdata="countrysharechartyoydata"
          />
        </el-col>
        <el-col :span="4">
          <ul class="chartcolortxt">
            <li><span class="color-europe"></span>{{ $t('charttxt.z4') }}</li>
            <li><span class="color-north-america"></span>{{ $t('charttxt.z3') }}</li>
            <li :title="$t('charttxt.z7')"><span class="color-latin-america-caribbean"></span>{{ $t('charttxt.z7') }}</li>
            <li><span class="color-oceania"></span>{{ $t('charttxt.z5') }}</li>
            <li><span class="color-asia"></span>{{ $t('charttxt.z2') }}</li>
            <li><span class="color-africa"></span>{{ $t('charttxt.z1') }}</li>
            <li><span class="color-others"></span>{{ $t('charttxt.z6') }}</li>
          </ul>
        </el-col>
      </el-row>
      <ChartNoData v-if="!hasdatachart3" />
    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 3">
      <h2>{{ charttitle4 }}</h2>
      <BarChart
        v-if="hasdatachart4"
        chartid="trendid"
        charttitle="Import Volume Trend" 
        :chartdata="top10countrydata"
      />
      <ChartNoData v-if="!hasdatachart4" />
    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 4">
      <h2>{{ charttitle5 }}</h2>
      <el-row :gutter="0" v-if="hasdatachart5">
        <el-col :span="20">
          <TreemapChart 
            chartid="countrysharechartid"
            charttitle="Import Volume Trend" 
            :tooltip1="tooltip1"
            :tooltip2="tooltip3"
            :tooltip3="tooltip99"
            :chartdata="registrationprovincechartdata"
          />
        </el-col>
        <el-col :span="4">
          <ul class="chartcolortxt">
            <li><span class="color1new"></span>{{ $t('charttxt.y1') }}</li>
            <li><span class="color2new"></span>{{ $t('charttxt.y2') }}</li>
            <li><span class="color3new"></span>{{ $t('charttxt.y3') }}</li>
            <li><span class="color4new"></span>{{ $t('charttxt.y4') }}</li>
            <li><span class="color5new"></span>{{ $t('charttxt.y5') }}</li>
            <li><span class="color6new"></span>{{ $t('charttxt.y6') }}</li>
            <li><span class="color7new"></span>{{ $t('charttxt.y7') }}</li>
          </ul>
        </el-col>
      </el-row>
      <ChartNoData v-if="!hasdatachart5" />
    </div>

    <div class="single-code-analysis-chart" v-if="currentchartindex === 5">
      <h2>{{ charttitle6 }}</h2>
      <TreemapChart 
        v-if="hasdatachart6"
        chartid="countrysharechartid"
        charttitle="Import Volume Trend" 
        :tooltip1="tooltip1"
        :tooltip2="tooltip3"
        :tooltip3="tooltip99"
        :chartdata="trademodechartdata"
      />
      <ChartNoData v-if="!hasdatachart6" />
    </div>

    <div class="chartnavigation">
      <div class="chartpagegroup">
        <el-button type="text" icon="el-icon-arrow-left" :disabled="prevbtn" @click="onPrevButton()"></el-button>
        <span class="chartpage">{{ currentchartindex + 1 }} {{ $t('charttxt.chartpage') }}</span>
        <el-button type="text" icon="el-icon-arrow-right" :disabled="nextbtn" @click="onNextButton()"></el-button>
      </div>      
    </div>

  </div>

</template>

<script>
import BarChart from '../components/SingleCodeAnalysisCharts/BarChart.vue'
import TreemapChart from '../components/SingleCodeAnalysisCharts/TreemapChart.vue'
import ScatterChart from '../components/SingleCodeAnalysisCharts/ScatterChart.vue'
import ChartNoData from '../components/SingleCodeAnalysisCharts/ChartNoData.vue'
export default {
  components: {
    BarChart,
    TreemapChart,
    ScatterChart,
    ChartNoData
  },
  data(){
    return{
      xtitle: '',
      ytitle: '',
      tooltip1: '',
      tooltip2: '',
      tooltip3: '',
      tooltip99: '',

      charttitle1: '',
      charttitle2: '',
      charttitle3: '',
      charttitle4: '',
      charttitle5: '',
      charttitle6: '',

      activebtn1: '',
      activebtn2: '',
      activebtn3: '',
      activebtn4: '',
      currentchartindex: 0,
      prevbtn: true,
      nextbtn: false,
      filedbtndisabled: true,
      tabdata:{
        lastcount: '-',
        lastpercent: '-',
        lastunit: '-',
        last3monthscount: '-',
        last3monthspercent: '-',
        last3monthsunit: '-',
        ytdcount: '-',
        ytdpercent: '-',
        ytdunit: '-',
        matcount: '-',
        matpercent: '-',
        matunit: '-'
      },
      searchcodeid: '', // 代码
      searchflow: 'import', // 进出口
      searchindex: 'value', // 指标：数量, 金额
      searchunit: 'first_unit', // 单位：数量->第一单位,第二单位； 金额->RMB,USD
      searchunit2: 'usd',
      searchperiod: '', //时间月份
      searchperiodops: '',
      searchperiodstr: '',
      // pickerOptions:{
      //   disabledDate(time) {
      //     /**
      //      * 禁止选择下个月及两年前的数据
      //      */
      //     let olddateobj = new Date(this.searchperiod)
      //     let newdateobj = new Date(this.searchperiod)
      //     let olddate = olddateobj.setMonth(olddateobj.getMonth() - 23)
      //     let newdate = newdateobj.setMonth(newdateobj.getMonth())
      //     return time.getTime() > newdate || time.getTime() < olddate
      //   },
      // },
      searchcodeidoptions: [
        // 已选的代码列表
      ],
      searchflowoptions: [{
        // 进出口
        value: 'import',
        label: this.$t('charttxt.t1')
      }, {
        value: 'export',
        label: this.$t('charttxt.t2')
      }],
      searchindexoptions: [{
        value: "value",
        label: this.$t('charttxt.t3')
      },{
        // 指标
        // average_price 平均暂时先不放
        value: "volume",
        label: this.$t('charttxt.t4')
      }],
      searchunitoptions: [{
        // 单位:数量
        value: "first_unit",
        label: this.$t('charttxt.t7')
      }, {
        value: "second_unit",
        label: this.$t('charttxt.t8')
      }],
      searchunitoptions2: [{
        value: "usd",
        label: this.$t('charttxt.t5')
      },{
        // 单位:金额
        value: "rmb",
        label: this.$t('charttxt.t6')
      }],
      currentcodelabel: '', // 当前选中的代码名称
      resultlineperiod: '',
      resultlinelatest3months: this.$t('SingleCodeAnalysis.t06'),
      resultlineytd: '',
      resultlinemat: '',

      linechartdata: {}, // 柱状图

      top10countrydata: {},
      top10currentlistdata: {},
      top10last3monthslistdata: {},
      top10ytdlistdata: {},
      top10matlistdata: {},

      countrysharechartdata: [], // 面积图
      currentlistdata: [],
      last3monthslistdata: [],
      ytdlistdata: [],
      matlistdata: [],

      countrysharechartyoydata: [], // 散点图
      countrysharechartyoycurrentlist: [],
      countrysharechartyoylast3monthslist: [],
      countrysharechartyoyytdlist: [],
      countrysharechartyoymatlist: [],
      
      registrationprovincechartdata: [], // 面积图
      registrationprovincecurrentlistdata: [],
      registrationprovincelast3monthslistdata: [],
      registrationprovinceytdlistdata: [],
      registrationprovincematlistdata: [],
      
      trademodechartdata: [], // 面积图
      trademodecurrentlistdata: [],
      trademodelast3monthslistdata: [],
      trademodeytdlistdata: [],
      trademodeematlistdata: [],

      /**
       * 是否有数据
       */
      hasdatachart1: true,
      hasdatachart2: true,
      hasdatachart3: true,
      hasdatachart4: true,
      hasdatachart5: true,
      hasdatachart6: true,
      
    }
  },
  
  computed: {  
    pickerOptions() {
       let that=this;
       return {
         disabledDate(time) {
          //let olddateobj = new Date(that.searchperiodops)
          let newdateobj = new Date(that.searchperiodops)
          let olddateobj = new Date('2018-12')
          let olddate = olddateobj.setMonth(olddateobj.getMonth())
          let newdate = newdateobj.setMonth(newdateobj.getMonth())
          return time.getTime() > newdate || time.getTime() < olddate
         }
       }
     }
  },

  mounted(){
    
    if(localStorage.getItem("currentcodeid")){
      this.loadCurrentData()
    }else{
      this.getCodelists()
    }

    //this.getCodelists()
    if(this.currentchartindex === 0){
      this.prevbtn = true
      this.nextbtn = false
      this.filedbtndisabled = true
    }
    if(this.currentchartindex === 1){
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
    }
    if(this.currentchartindex === 2){
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
    }
    if(this.currentchartindex === 3){
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
    }
    if(this.currentchartindex === 4){
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
    }
    if(this.currentchartindex === 5){
      this.prevbtn = false
      this.nextbtn = true
      this.filedbtndisabled = false
    }
  },

  methods: {

    /**
     * 从SubscribeCodes跳转
     */
    loadCurrentData: function(){
      let that=this
      that.searchcodeid = JSON.parse(localStorage.getItem("currentcodeid")).val
      that.getCodeLatest(that.searchcodeid, function(){
        that.confirmSelect()
        that.getCodelists()
        //localStorage.removeItem("currentcodeid")
      })      
    },

    /**
     * 确认选择按钮
     */
    confirmSelect: function(){
      let querydata = {
        code: this.searchcodeid,
        flow: this.searchflow,
        index: this.searchindex,
        unit: this.searchunit,
        currency: this.searchunit2,
        lastMonth: this.searchperiod
      }

      let _tabdataobj = {
        lastcount: '-',
        lastpercent: '-',
        lastunit: '-',
        last3monthscount: '-',
        last3monthspercent: '-',
        last3monthsunit: '-',
        ytdcount: '-',
        ytdpercent: '-',
        ytdunit: '-',
        matcount: '-',
        matpercent: '-',
        matunit: '-'
      }
      this.tabdata = _tabdataobj

      /**
       * 图表标题
       */
      //进口-第一计量单位
      if(this.searchflow === 'import' && this.searchindex === 'volume' && this.searchunit === 'first_unit'){
        this.charttitle1 = this.$t('charttxt.t0001')
        this.charttitle2 = this.$t('charttxt.t1001')
        this.charttitle3 = this.$t('charttxt.t3001')
        this.charttitle4 = this.$t('charttxt.t4001')
        this.charttitle5 = this.$t('charttxt.t5001')
        this.charttitle6 = this.$t('charttxt.t6001')
        this.xtitle= this.$t('charttxt.ctitle03x1')
        this.ytitle= this.$t('charttxt.ctitle03y1')
        this.tooltip1= this.$t('charttxt.tooltip11')
        this.tooltip2= this.$t('charttxt.tooltip21')
        this.tooltip3= this.$t('charttxt.tooltip31')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //进口-第二计量单位
      if(this.searchflow === 'import' && this.searchindex === 'volume' &&  this.searchunit === 'second_unit'){
        this.charttitle1 = this.$t('charttxt.t0003')
        this.charttitle2 = this.$t('charttxt.t1003')
        this.charttitle3 = this.$t('charttxt.t3003')
        this.charttitle4 = this.$t('charttxt.t4003')
        this.charttitle5 = this.$t('charttxt.t5003')
        this.charttitle6 = this.$t('charttxt.t6003')
        this.xtitle= this.$t('charttxt.ctitle03x1')
        this.ytitle= this.$t('charttxt.ctitle03y1')
        this.tooltip1= this.$t('charttxt.tooltip11')
        this.tooltip2= this.$t('charttxt.tooltip21')
        this.tooltip3= this.$t('charttxt.tooltip31')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //出口-第一计量单位
      if(this.searchflow === 'export' && this.searchindex === 'volume' &&  this.searchunit === 'first_unit'){
        this.charttitle1 = this.$t('charttxt.t0002')
        this.charttitle2 = this.$t('charttxt.t1002')
        this.charttitle3 = this.$t('charttxt.t3002')
        this.charttitle4 = this.$t('charttxt.t4002')
        this.charttitle5 = this.$t('charttxt.t5002')
        this.charttitle6 = this.$t('charttxt.t6002')
        this.xtitle= this.$t('charttxt.ctitle03x2')
        this.ytitle= this.$t('charttxt.ctitle03y2')
        this.tooltip1= this.$t('charttxt.tooltip12')
        this.tooltip2= this.$t('charttxt.tooltip21')
        this.tooltip3= this.$t('charttxt.tooltip32')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //出口-第二计量单位
      if(this.searchflow === 'export' && this.searchindex === 'volume' &&  this.searchunit === 'second_unit'){
        this.charttitle1 = this.$t('charttxt.t0004')
        this.charttitle2 = this.$t('charttxt.t1004')
        this.charttitle3 = this.$t('charttxt.t3004')
        this.charttitle4 = this.$t('charttxt.t4004')
        this.charttitle5 = this.$t('charttxt.t5004')
        this.charttitle6 = this.$t('charttxt.t6004')
        this.xtitle= this.$t('charttxt.ctitle03x2')
        this.ytitle= this.$t('charttxt.ctitle03y2')
        this.tooltip1= this.$t('charttxt.tooltip12')
        this.tooltip2= this.$t('charttxt.tooltip21')
        this.tooltip3= this.$t('charttxt.tooltip32')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //进口-美元
      if(this.searchflow === 'import' && this.searchindex === 'value' &&  this.searchunit2 === 'usd'){
        this.charttitle1 = this.$t('charttxt.t0005')
        this.charttitle2 = this.$t('charttxt.t1005')
        this.charttitle3 = this.$t('charttxt.t3005')
        this.charttitle4 = this.$t('charttxt.t4005')
        this.charttitle5 = this.$t('charttxt.t5005')
        this.charttitle6 = this.$t('charttxt.t6005')
        this.xtitle= this.$t('charttxt.ctitle03x3')
        this.ytitle= this.$t('charttxt.ctitle03y3')
        this.tooltip1= this.$t('charttxt.tooltip11')
        this.tooltip2= this.$t('charttxt.tooltip22')
        this.tooltip3= this.$t('charttxt.tooltip33')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //进口-人民币
      if(this.searchflow === 'import' && this.searchindex === 'value' &&  this.searchunit2 === 'rmb'){
        this.charttitle1 = this.$t('charttxt.t0007')
        this.charttitle2 = this.$t('charttxt.t1007')
        this.charttitle3 = this.$t('charttxt.t3007')
        this.charttitle4 = this.$t('charttxt.t4007')
        this.charttitle5 = this.$t('charttxt.t5007')
        this.charttitle6 = this.$t('charttxt.t6007')
        this.xtitle= this.$t('charttxt.ctitle03x3')
        this.ytitle= this.$t('charttxt.ctitle03y3')
        this.tooltip1= this.$t('charttxt.tooltip11')
        this.tooltip2= this.$t('charttxt.tooltip22')
        this.tooltip3= this.$t('charttxt.tooltip33')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //出口-美元
      if(this.searchflow === 'export' && this.searchindex === 'value' &&  this.searchunit2 === 'usd'){
        this.charttitle1 = this.$t('charttxt.t0006')
        this.charttitle2 = this.$t('charttxt.t1006')
        this.charttitle3 = this.$t('charttxt.t3006')
        this.charttitle4 = this.$t('charttxt.t4006')
        this.charttitle5 = this.$t('charttxt.t5006')
        this.charttitle6 = this.$t('charttxt.t6006')
        this.xtitle= this.$t('charttxt.ctitle03x4')
        this.ytitle= this.$t('charttxt.ctitle03y4')
        this.tooltip1= this.$t('charttxt.tooltip12')
        this.tooltip2= this.$t('charttxt.tooltip22')
        this.tooltip3= this.$t('charttxt.tooltip34')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }
      //出口-人民币
      if(this.searchflow === 'export' &&  this.searchindex === 'value' && this.searchunit2 === 'rmb'){
        this.charttitle1 = this.$t('charttxt.t0008')
        this.charttitle2 = this.$t('charttxt.t1008')
        this.charttitle3 = this.$t('charttxt.t3008')
        this.charttitle4 = this.$t('charttxt.t4008')
        this.charttitle5 = this.$t('charttxt.t5008')
        this.charttitle6 = this.$t('charttxt.t6008')
        this.xtitle= this.$t('charttxt.ctitle03x4')
        this.ytitle= this.$t('charttxt.ctitle03y4')
        this.tooltip1= this.$t('charttxt.tooltip12')
        this.tooltip2= this.$t('charttxt.tooltip22')
        this.tooltip3= this.$t('charttxt.tooltip34')
        this.tooltip99= this.$t('charttxt.tooltip99')
      }

      this.resultlineperiod = this.searchperiod
      this.resultlineytd= this.$t('SingleCodeAnalysis.t07') + this.searchperiod
      this.resultlinemat= this.$t('SingleCodeAnalysis.t08') + this.searchperiod

      // console.log('confirmSelect1', this.activebtn1)
      // console.log('confirmSelect2', this.activebtn2)
      // console.log('confirmSelect3', this.activebtn3)
      // console.log('confirmSelect4', this.activebtn4)

      this.getTitle(this.searchcodeid)
      /**
       * 图4
       */
      this.setCountryShareYoyGrowthChart(querydata)
      /**
       * 图3
       */
      this.setCountryShareChart(querydata)
      /**
       * 图5
       */
      this.setRegistrationProvinceChart(querydata)
      /**
       * 图6
       */
      this.setTradeModeChart(querydata)
      /**
       * 图1
       */
      this.setTrendChart(querydata)
      
    },

    /**
     * 获取Code标题
     */
    getTitle: function(cid){
      let n = ''
      for(var i=0; i< this.searchcodeidoptions.length; i++){
        if(this.searchcodeidoptions[i].value === cid){
          n = this.searchcodeidoptions[i].label
          i = this.searchcodeidoptions.length
        }
      }
      this.currentcodelabel = n
    },

    /**
     * 上一个图表按钮
     * 共6个图表
     */
    onPrevButton: function(){
      this.currentchartindex = this.currentchartindex - 1
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
      if(this.currentchartindex === 0){
        this.prevbtn = true
        this.filedbtndisabled = true      
        this.activebtn1 = ''
        this.activebtn2 = ''
        this.activebtn3 = ''
        this.activebtn4 = ''
      }
    },

    /**
     * 下一个图表按钮
     */
    onNextButton: function(){
      this.currentchartindex = this.currentchartindex + 1
      this.prevbtn = false
      this.nextbtn = false
      this.filedbtndisabled = false
      this.onLastcount()
      if(this.currentchartindex === 5){
        this.nextbtn = true
      }
    },

    /**
     * onLastcount
     */
    onLastcount: function(){
      this.activebtn1 = 'activethisbtn'
      this.activebtn2 = ''
      this.activebtn3 = ''
      this.activebtn4 = ''
      this.top10countrydata={}
      this.top10countrydata= this.top10currentlistdata
      this.countrysharechartdata = this.currentlistdata
      this.registrationprovincechartdata = this.registrationprovincecurrentlistdata
      this.trademodechartdata = this.trademodecurrentlistdata
      this.countrysharechartyoydata = this.countrysharechartyoycurrentlist
    },
      
    /**
     * onLast3Monthsount
     */
    onLast3Monthsount: function(){
      this.activebtn1 = ''
      this.activebtn2 = 'activethisbtn'
      this.activebtn3 = ''
      this.activebtn4 = ''
      this.top10countrydata={}
      this.top10countrydata= this.top10last3monthslistdata
      this.countrysharechartdata = this.last3monthslistdata
      this.registrationprovincechartdata = this.registrationprovincelast3monthslistdata
      this.trademodechartdata = this.trademodelast3monthslistdata
      this.countrysharechartyoydata = this.countrysharechartyoylast3monthslist
    },

    /**
     * onYtdcount
     */
    onYtdcount: function(){
      this.activebtn1 = ''
      this.activebtn2 = ''
      this.activebtn3 = 'activethisbtn'
      this.activebtn4 = ''
      this.top10countrydata={}
      this.top10countrydata= this.top10ytdlistdata
      this.countrysharechartdata = this.ytdlistdata
      this.registrationprovincechartdata = this.registrationprovinceytdlistdata
      this.trademodechartdata = this.trademodeytdlistdata
      this.countrysharechartyoydata = this.countrysharechartyoyytdlist
    },

    /**
     * onMatcount
     */
    onMatcount: function(){
      this.activebtn1 = ''
      this.activebtn2 = ''
      this.activebtn3 = ''
      this.activebtn4 = 'activethisbtn'
      this.top10countrydata={}
      this.top10countrydata= this.top10matlistdata
      this.countrysharechartdata = this.matlistdata
      this.registrationprovincechartdata = this.registrationprovincematlistdata
      this.trademodechartdata = this.trademodematlistdata
      this.countrysharechartyoydata = this.countrysharechartyoymatlist
    },

    /**
     * 获取购物车
     */
    getCodelists: function(){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/cart/info?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      that.subscribedcode = []
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log(rex)
          let codelists = rex.data.cartList.code_list
          let codeobj = []
          for(var i=0 ;i<codelists.length; i++){
            let codeitem = {}
            codeitem.value = codelists[i].code
            codeitem.label = codelists[i].title
            codeobj.push(codeitem)
          }
          that.searchcodeidoptions = codeobj
          if(!localStorage.getItem("currentcodeid")){
            that.searchcodeid = codeobj[0].value
            //let nowdate = new Date
            //that.searchperiod = that.moment(nowdate,'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYY-MM')
            that.getCodeLatest(codeobj[0].value, function(){
              that.confirmSelect()
            })
          }else{
            that.getTitle(that.searchcodeid)
            localStorage.removeItem("currentcodeid")
          }
          
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 获取最新月份
     */
    getCodeLatest: function(code, callback){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/code-last-year-month?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
                  +'&code='+code
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('getCodeLatest', rex)
          that.searchperiod = rex.data.year_month
          that.searchperiodops = rex.data.year_month
          callback()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 切换Code获取最新时间
     */
    changeCode: function(selchange){
      let that = this
      that.getCodeLatest(selchange, function(){
        return
      })
    },    

    /**
     * 图1
     */
    setTrendChart: function(querydata){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/trend?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: querydata,
        success: function(rex) {
          console.log('图1', rex)
          if(rex.code === 400){
            that.hasdatachart1 = false
          }else{
            that.hasdatachart1 = true
            let dataobj = rex.data
            that.tabdata.lastcount= that.millonFormat(dataobj.current.value)
            that.tabdata.lastpercent= dataobj.current.growth_yoy + '%'
            that.tabdata.lastunit= that.searchindex === 'volume' ? dataobj.current.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            that.tabdata.last3monthscount= that.millonFormat(dataobj.lastThreeMonth.value)
            that.tabdata.last3monthspercent= dataobj.lastThreeMonth.growth_yoy + '%'
            that.tabdata.last3monthsunit= that.searchindex === 'volume' ? dataobj.lastThreeMonth.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            that.tabdata.ytdcount= that.millonFormat(dataobj.YTD.value)
            that.tabdata.ytdpercent= dataobj.YTD.growth_yoy + '%'
            that.tabdata.ytdunit= that.searchindex === 'volume' ? dataobj.YTD.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            that.tabdata.matcount= that.millonFormat(dataobj.MAT.value)
            that.tabdata.matpercent= dataobj.MAT.growth_yoy + '%'
            that.tabdata.matunit= that.searchindex === 'volume' ? dataobj.MAT.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')

            /**
             * Trend
             */
            let lineChartDataObj = dataobj.MATList

            /**
             * 检查近24月数据value值相加是否为0: 0代表无数据
             */
            let checklistisnull = 0
            for(let x=0; x<lineChartDataObj.length; x++){
              checklistisnull = checklistisnull + lineChartDataObj[x].value
            }
            if(checklistisnull === 0){
              that.hasdatachart1 = false
              return
            }

            let x = [];
            let y = [];
            for (var i = 0; i < lineChartDataObj.length; i++) {
                x[i] = lineChartDataObj[i].item
                y[i] = lineChartDataObj[i].value
            }
            
            that.linechartdata = {
              gridbottom: {
                left: 100,
                right: 25
              },
              axisLabelrotate: 45,
              // yAxisFormatter: function(value){
              //   let res = ''
              //   if(value<1000){
              //     res = value
              //   }
              //   if(value>=1000 && value < 1000000){
              //     res = (value/1000) + '千'
              //   }
              //   if(value >= 1000000){
              //     res = (value/1000000) + '百万'
              //   }
              //   return res
              // },
              tooltipFormatter: function (params) {
                return params[0].name + ': ' + that.millonFormat(params[0].value)
              },
              xAxis: x,
              yAxis: [{
                type:'bar',
                data: y,
                barWidth: '65%',
                markLine : {
                  symbol:"none",
                  label: {
                    show: true,
                    fontSize: 14,
                    fontWeight: 'bold',
                    position: 'middle',
                    formatter: function (params) {
                      return that.$t('charttxt.average24') + that.millonFormat((params.data.value).toFixed(0))
                    }
                  },
                  lineStyle: {
                    normal: {
                      color: "rgb(221, 65, 36)"
                    }
                  },
                  data : [{
                    type : 'average', 
                    name : that.$t('charttxt.average24')
                  }]
                },
                axisLabel: {
                  color: "#336699"
                }
              }],
              color: ['rgba(132,151,176,.5)']
            }            
          }

        },
        error: function(response) {
          console.log(response)
        }
      })
    },


    /**
     * 图3
     */
    setCountryShareChart: function(querydata){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/country-share?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: querydata,
        success: function(rex) {
          console.log('图2&图3', rex)
          
          if(rex.code === 400){
            that.hasdatachart2 = false
            that.hasdatachart3 = false
          }else{
            that.hasdatachart2 = true
            that.hasdatachart3 = true

            let thisdata = rex.data

            let currentlistdata = thisdata.currentList
            currentlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            currentlistdata = that.setCountyArea(currentlistdata)
            
            let scatterdata1 = []
            let x1 = Math.max.apply(Math,thisdata.currentList.map(item => { return item.value }))
            let y1 = 100/x1
            for(let i=0; i<thisdata.currentList.length; i++){
              scatterdata1.push([
                thisdata.currentList[i].proportion, //X轴
                thisdata.currentList[i].growth, //Y轴，同期增量绝对值
                thisdata.currentList[i].item, //名称
                thisdata.currentList[i].value * y1, //圆圈大小，当前value数值
                thisdata.currentList[i].growth_yoy,
                thisdata.currentList[i].continent, //洲
                that.searchindex === 'volume' ? thisdata.currentList[i].unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5'),
                thisdata.MATList[i].value
              ])
            }
            that.currentlistdata = currentlistdata
            that.countrysharechartyoycurrentlist = scatterdata1
            
            let last3monthslistdata = thisdata.lastThreeMonthList
            last3monthslistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            last3monthslistdata = that.setCountyArea(last3monthslistdata)

            let scatterdata2 = []
            let x2 = Math.max.apply(Math,thisdata.lastThreeMonthList.map(item => { return item.value }))
            let y2 = 100/x2
            for(let i=0; i<thisdata.lastThreeMonthList.length; i++){
              scatterdata2.push([
                thisdata.lastThreeMonthList[i].proportion, //X轴
                thisdata.lastThreeMonthList[i].growth, //Y轴，同期增量绝对值
                thisdata.lastThreeMonthList[i].item, //名称
                thisdata.lastThreeMonthList[i].value * y2, //圆圈大小，当前value数值
                thisdata.lastThreeMonthList[i].growth_yoy, 
                thisdata.lastThreeMonthList[i].continent, //洲
                that.searchindex === 'volume' ? thisdata.lastThreeMonthList[i].unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5'),
                thisdata.MATList[i].value
              ])
            }
            that.last3monthslistdata = last3monthslistdata
            that.countrysharechartyoylast3monthslist = scatterdata2

            let ytdlistdata = thisdata.YTDList
            ytdlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            ytdlistdata = that.setCountyArea(ytdlistdata)

            let scatterdata3 = []
            let x3 = Math.max.apply(Math,thisdata.YTDList.map(item => { return item.value }))
            let y3 = 100/x3
            for(let i=0; i<thisdata.YTDList.length; i++){
              scatterdata3.push([
                thisdata.YTDList[i].proportion, //X轴
                thisdata.YTDList[i].growth, //Y轴，同期增量绝对值
                thisdata.YTDList[i].item, //名称
                thisdata.YTDList[i].value * y3, //圆圈大小，当前value数值
                thisdata.YTDList[i].growth_yoy, 
                thisdata.YTDList[i].continent, //洲
                that.searchindex === 'volume' ? thisdata.YTDList[i].unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5'),
                thisdata.MATList[i].value
              ])
            }
            that.ytdlistdata= ytdlistdata
            that.countrysharechartyoyytdlist = scatterdata3

            let matlistdata = thisdata.MATList
            matlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            matlistdata = that.setCountyArea(matlistdata)
            
            let scatterdata4 = []
            let x4 = Math.max.apply(Math,thisdata.MATList.map(item => { return item.value }))
            let y4 = 100/x4
            for(let i=0; i<thisdata.MATList.length; i++){
              scatterdata4.push([
                thisdata.MATList[i].proportion, //X轴
                thisdata.MATList[i].growth, //Y轴，同期增量绝对值
                thisdata.MATList[i].item, //名称
                thisdata.MATList[i].value * y4, //圆圈大小，当前value数值
                thisdata.MATList[i].growth_yoy, 
                thisdata.MATList[i].continent, //洲
                that.searchindex === 'volume' ? thisdata.MATList[i].unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5'),
                thisdata.MATList[i].value
              ])
            }
            that.matlistdata= matlistdata
            that.countrysharechartyoymatlist = scatterdata4
            
            /**
             * 图2 & 图3
             */
            if(that.activebtn1 == '' && that.activebtn2 == '' && that.activebtn3 == '' && that.activebtn4 == ''){
              if(currentlistdata.length === 1 && currentlistdata[0].value/1 === 0){
                that.hasdatachart2 = false
                that.hasdatachart3 = false                
              }else{
                that.hasdatachart2 = true
                that.hasdatachart3 = true                
              }
              that.countrysharechartdata = currentlistdata
              that.countrysharechartyoydata = scatterdata1
            }
            if(that.activebtn1 === 'activethisbtn'){
              if(currentlistdata.length === 1 && currentlistdata[0].value/1 === 0){
                that.hasdatachart2 = false
                that.hasdatachart3 = false                
              }else{
                that.hasdatachart2 = true
                that.hasdatachart3 = true                
              }
              that.countrysharechartdata = currentlistdata
              that.countrysharechartyoydata = scatterdata1
            }
            if(that.activebtn2 === 'activethisbtn'){
              if(last3monthslistdata.length === 1 && last3monthslistdata[0].value/1 === 0){
                that.hasdatachart2 = false
                that.hasdatachart3 = false                
              }else{
                that.hasdatachart2 = true
                that.hasdatachart3 = true                
              }
              that.countrysharechartdata = last3monthslistdata
              that.countrysharechartyoydata = scatterdata2
            }
            if(that.activebtn3 === 'activethisbtn'){
              if(ytdlistdata.length === 1 && ytdlistdata[0].value/1 === 0){
                that.hasdatachart2 = false
                that.hasdatachart3 = false                
              }else{
                that.hasdatachart2 = true
                that.hasdatachart3 = true                
              }
              that.countrysharechartdata = ytdlistdata
              that.countrysharechartyoydata = scatterdata3
            }
            if(that.activebtn4 === 'activethisbtn'){
              if(matlistdata.length === 1 && matlistdata[0].value/1 === 0){
                that.hasdatachart2 = false
                that.hasdatachart3 = false                
              }else{
                that.hasdatachart2 = true
                that.hasdatachart3 = true                
              }
              that.countrysharechartdata = matlistdata
              that.countrysharechartyoydata = scatterdata4
            }
          }

        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 图4
     */
    setCountryShareYoyGrowthChart: function(querydata){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/country-share-yoy-growth?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: querydata,
        success: function(rex) {
          console.log('图4', rex)

          if(rex.code === 400){
            that.hasdatachart4 = false
          }else{
            that.hasdatachart4 = true
            let dataobj = rex.data

            /**
             * Trend
             */

            // 最近一月
            let tab1data = dataobj.currentList
            let tab1datax = [];
            let tab1datay = [];
            for (let i = 0; i < tab1data.length; i++) {
                tab1datax[i] = tab1data[i].item
                tab1datay[i] = tab1data[i].growth
            }
            that.top10currentlistdata = {
              gridbottom: {
                bottom: 30
              },
              //axisLabelrotate: 45,
              tooltipFormatter: function (params) {
                return params[0].name + ': ' + that.millonFormat(params[0].value)
              },
              //tooltipFormatter: '{b} : {c}',
              //yAxisFormatter: '{value}%',
              xAxis: tab1datax,
              yAxis: [{
                type:'bar',
                data: tab1datay.sort(function(a,b){
                  return b-a;
                }),
                barWidth: '40%',
              }],
              color: ['rgba(132,151,176,.5)']
            }

            //最近三月
            let tab2data = dataobj.lastThreeMonthList
            let tab2datax = [];
            let tab2datay = [];
            for (let i = 0; i < tab2data.length; i++) {
                tab2datax[i] = tab2data[i].item
                tab2datay[i] = tab2data[i].growth
            }
            that.top10last3monthslistdata = {
              gridbottom: {
                bottom: 30
              },
              //axisLabelrotate: 45,
              tooltipFormatter: function (params) {
                return params[0].name + ': ' + that.millonFormat(params[0].value)
              },
              //tooltipFormatter: '{b} : {c}',
              //yAxisFormatter: '{value}%',
              xAxis: tab2datax,
              yAxis: [{
                type:'bar',
                data: tab2datay.sort(function(a,b){
                  return b-a;
                }),
                barWidth: '40%',
              }],
              color: ['rgba(132,151,176,.5)']
            }
            
            //YTD
            let tab3data = dataobj.YTDList
            let tab3datax = [];
            let tab3datay = [];
            for (let i = 0; i < tab3data.length; i++) {
                tab3datax[i] = tab3data[i].item
                tab3datay[i] = tab3data[i].growth
            }
            that.top10ytdlistdata = {
              gridbottom: {
                bottom: 30
              },
              //axisLabelrotate: 45,
              tooltipFormatter: function (params) {
                return params[0].name + ': ' + that.millonFormat(params[0].value)
              },
              //tooltipFormatter: '{b} : {c}',
              //yAxisFormatter: '{value}%',
              xAxis: tab3datax,
              yAxis: [{
                type:'bar',
                data: tab3datay.sort(function(a,b){
                  return b-a;
                }),
                barWidth: '40%',
              }],
              color: ['rgba(132,151,176,.5)']
            }
            
            //MAT
            let tab4data = dataobj.MATList
            let tab4datax = [];
            let tab4datay = [];
            for (let i = 0; i < tab4data.length; i++) {
                tab4datax[i] = tab4data[i].item
                tab4datay[i] = tab4data[i].growth
            }
            that.top10matlistdata = {
              gridbottom: {
                bottom: 30
              },
              //axisLabelrotate: 45,
              tooltipFormatter: function (params) {
                return params[0].name + ': ' + that.millonFormat(params[0].value)
              },
              //tooltipFormatter: '{b} : {c}',
              //yAxisFormatter: '{value}%',
              xAxis: tab4datax,
              yAxis: [{
                type:'bar',
                data: tab4datay.sort(function(a,b){
                  return b-a;
                }),
                barWidth: '40%',
              }],
              color: ['rgba(132,151,176,.5)']
            }

            /**
             * 图4
             */
            if(that.activebtn1 == '' && that.activebtn2 == '' && that.activebtn3 == '' && that.activebtn4 == ''){
              if(that.top10currentlistdata.xAxis.length === 1 && 
                  that.top10currentlistdata.yAxis.length === 1 &&
                  that.top10currentlistdata.yAxis[0].data.length === 1 &&
                  that.top10currentlistdata.yAxis[0].data[0]/1 === 0){
                that.hasdatachart4 = false          
              }else{
                that.hasdatachart4 = true       
              }
              that.top10countrydata= that.top10currentlistdata
            }
            if(that.activebtn1 === 'activethisbtn'){
              if(that.top10currentlistdata.xAxis.length === 1 && 
                  that.top10currentlistdata.yAxis.length === 1 &&
                  that.top10currentlistdata.yAxis[0].data.length === 1 &&
                  that.top10currentlistdata.yAxis[0].data[0]/1 === 0){
                that.hasdatachart4 = false          
              }else{
                that.hasdatachart4 = true       
              }
              that.top10countrydata= that.top10currentlistdata
            }
            if(that.activebtn2 === 'activethisbtn'){
              if(that.top10last3monthslistdata.xAxis.length === 1 && 
                  that.top10last3monthslistdata.yAxis.length === 1 &&
                  that.top10last3monthslistdata.yAxis[0].data.length === 1 &&
                  that.top10last3monthslistdata.yAxis[0].data[0]/1 === 0){
                that.hasdatachart4 = false          
              }else{
                that.hasdatachart4 = true       
              }
              that.top10countrydata= that.top10last3monthslistdata
            }
            if(that.activebtn3 === 'activethisbtn'){
              if(that.top10ytdlistdata.xAxis.length === 1 && 
                  that.top10ytdlistdata.yAxis.length === 1 &&
                  that.top10ytdlistdata.yAxis[0].data.length === 1 &&
                  that.top10ytdlistdata.yAxis[0].data[0]/1 === 0){
                that.hasdatachart4 = false          
              }else{
                that.hasdatachart4 = true       
              }
              that.top10countrydata= that.top10ytdlistdata
            }
            if(that.activebtn4 === 'activethisbtn'){
              if(that.top10matlistdata.xAxis.length === 1 && 
                  that.top10matlistdata.yAxis.length === 1 &&
                  that.top10matlistdata.yAxis[0].data.length === 1 &&
                  that.top10matlistdata.yAxis[0].data[0]/1 === 0){
                that.hasdatachart4 = false          
              }else{
                that.hasdatachart4 = true       
              }
              that.top10countrydata= that.top10matlistdata
            }
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },    

    /**
     * 图5
     */
    setRegistrationProvinceChart: function(querydata){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/registration-province?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: querydata,
        success: function(rex) {
          console.log('图5', rex)
          if(rex.code === 400){
            that.hasdatachart5 = false
          }else{
            that.hasdatachart5 = true
            let thisdata = rex.data
            let currentlistdata = thisdata.currentList
            currentlistdata = that.setProvinceArea(currentlistdata)
            that.registrationprovincecurrentlistdata = currentlistdata

            let last3monthslistdata = thisdata.lastThreeMonthList
            last3monthslistdata = that.setProvinceArea(last3monthslistdata)
            that.registrationprovincelast3monthslistdata = last3monthslistdata

            let ytdlistdata = thisdata.YTDList
            ytdlistdata = that.setProvinceArea(ytdlistdata)
            that.registrationprovinceytdlistdata= ytdlistdata

            let matlistdata = thisdata.MATList
            matlistdata = that.setProvinceArea(matlistdata)
            that.registrationprovincematlistdata= matlistdata

            /**
             * 图5
             */
            if(that.activebtn1 == '' && that.activebtn2 == '' && that.activebtn3 == '' && that.activebtn4 == ''){
              if(that.registrationprovincecurrentlistdata.length === 1 && that.registrationprovincecurrentlistdata[0].value/1 === 0){
                that.hasdatachart5 = false               
              }else{
                that.hasdatachart5 = true              
              }
              that.registrationprovincechartdata = that.registrationprovincecurrentlistdata
            }
            if(that.activebtn1 === 'activethisbtn'){
              if(that.registrationprovincecurrentlistdata.length === 1 && that.registrationprovincecurrentlistdata[0].value/1 === 0){
                that.hasdatachart5 = false                
              }else{
                that.hasdatachart5 = true             
              }
              that.registrationprovincechartdata = that.registrationprovincecurrentlistdata
            }
            if(that.activebtn2 === 'activethisbtn'){
              if(that.registrationprovincelast3monthslistdata.length === 1 && that.registrationprovincelast3monthslistdata[0].value/1 === 0){
                that.hasdatachart5 = false            
              }else{
                that.hasdatachart5 = true            
              }
              that.registrationprovincechartdata = that.registrationprovincelast3monthslistdata
            }
            if(that.activebtn3 === 'activethisbtn'){
              if(that.registrationprovinceytdlistdata.length === 1 && that.registrationprovinceytdlistdata[0].value/1 === 0){
                that.hasdatachart5 = false              
              }else{
                that.hasdatachart5 = true            
              }
              that.registrationprovincechartdata = that.registrationprovinceytdlistdata
            }
            if(that.activebtn4 === 'activethisbtn'){
              if(that.registrationprovincematlistdata.length === 1 && that.registrationprovincematlistdata[0].value/1 === 0){
                that.hasdatachart5 = false               
              }else{
                that.hasdatachart5 = true             
              }
              that.registrationprovincechartdata = that.registrationprovincematlistdata
            }
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 图6
     */
    setTradeModeChart: function(querydata){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/chart/trade-mode?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: querydata,
        success: function(rex) {
          console.log('图6', rex)
          if(rex.code === 400){
            that.hasdatachart6 = false
          }else{
            that.hasdatachart6 = true
            let thisdata = rex.data
            let currentlistdata = thisdata.currentList
            currentlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            that.trademodecurrentlistdata = currentlistdata

            let last3monthslistdata = thisdata.lastThreeMonthList
            last3monthslistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            that.trademodelast3monthslistdata = last3monthslistdata

            let ytdlistdata = thisdata.YTDList
            ytdlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            that.trademodeytdlistdata= ytdlistdata

            let matlistdata = thisdata.MATList
            matlistdata.forEach(e => {
              e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
            })
            that.trademodematlistdata= matlistdata

            /**
             * 图6
             */
            if(that.activebtn1 == '' && that.activebtn2 == '' && that.activebtn3 == '' && that.activebtn4 == ''){
              if(that.trademodecurrentlistdata.length === 1 && that.trademodecurrentlistdata[0].value/1 === 0){
                that.hasdatachart6 = false               
              }else{
                that.hasdatachart6 = true              
              }
              that.trademodechartdata = that.trademodecurrentlistdata
            }
            if(that.activebtn1 === 'activethisbtn'){
              if(that.trademodecurrentlistdata.length === 1 && that.trademodecurrentlistdata[0].value/1 === 0){
                that.hasdatachart6 = false               
              }else{
                that.hasdatachart6 = true             
              }
              that.trademodechartdata = that.trademodecurrentlistdata
            }
            if(that.activebtn2 === 'activethisbtn'){
              if(that.trademodelast3monthslistdata.length === 1 && that.trademodelast3monthslistdata[0].value/1 === 0){
                that.hasdatachart6 = false               
              }else{
                that.hasdatachart6 = true             
              }
              that.trademodechartdata = that.trademodelast3monthslistdata
            }
            if(that.activebtn3 === 'activethisbtn'){
              if(that.trademodeytdlistdata.length === 1 && that.trademodeytdlistdata[0].value/1 === 0){
                that.hasdatachart6 = false               
              }else{
                that.hasdatachart6 = true             
              }
              that.trademodechartdata = that.trademodeytdlistdata
            }
            if(that.activebtn4 === 'activethisbtn'){
              if(that.trademodematlistdata.length === 1 && that.trademodematlistdata[0].value/1 === 0){
                that.hasdatachasdatachart6hart5 = false               
              }else{
                that.hasdatachart6 = true             
              }
              that.trademodechartdata = that.trademodematlistdata
            }
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 设置国家区域
     */
    setCountyArea: function(res){
      let that = this
      let grouparr = that._.groupBy(res,'continent')
      let _currentlistdata = []
      if(grouparr['北美洲'] || grouparr['南美洲'] || grouparr['North America'] || grouparr['South America']){
        let _americas = []
        if(grouparr['北美洲'] || grouparr['南美洲']){
          if(grouparr['北美洲'] && !grouparr['南美洲']){
            _americas = grouparr['北美洲']
          }
          if(grouparr['南美洲'] && !grouparr['北美洲']){
            _americas = grouparr['南美洲']
          }
          if(grouparr['南美洲'] && grouparr['北美洲']){
            _americas = that._.concat(grouparr['南美洲'], grouparr['北美洲'])
          }
        }
        if(grouparr['North America'] || grouparr['South America']){
          if(grouparr['North America'] && !grouparr['South America']){
            _americas = grouparr['North America']
          }
          if(grouparr['South America'] && !grouparr['North America']){
            _americas = grouparr['South America']
          }
          if(grouparr['South America'] && grouparr['North America']){
            _americas = that._.concat(grouparr['South America'], grouparr['North America'])
          }
        }
        let total1 = that._.map(_americas, 'value')
        _americas.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Americas = {
          name: '北美洲',
          value: total1.join('+'),
          itemStyle: {
            color: 'rgb(51, 102, 153)'
          },
          children: _americas
        }
        _currentlistdata.push(Americas)
      }
      if(grouparr['欧洲'] || grouparr['Europe']){
        let _europe = []
        if(grouparr['欧洲']){
          _europe = grouparr['欧洲']
        }
        if(grouparr['Europe']){
          _europe = grouparr['Europe']
        }
        let total2 = that._.map(_europe, 'value')
        _europe.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Europe = {
          name: '欧洲',
          value: total2.join('+'),
          itemStyle: {
            color: 'rgb(190, 69, 116)'
          },
          children: _europe
        }
        _currentlistdata.push(Europe)
      }
      if(grouparr['亚洲'] || grouparr['Asia']){
        let _asia = []
        if(grouparr['亚洲']){
          _asia = grouparr['亚洲']
        }
        if(grouparr['Asia']){
          _asia = grouparr['Asia']
        }
        let total3 = that._.map(_asia, 'value')
        _asia.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Asia = {
          name: '亚洲',
          value: total3.join('+'),
          itemStyle: {
            color: 'rgb(240, 192, 90)'
          },
          children: _asia
        }
        _currentlistdata.push(Asia)
      }
      if(grouparr['非洲'] || grouparr['Africa']){
        let _africa = []
        if(grouparr['非洲']){
          _africa = grouparr['非洲']
        }
        if(grouparr['Africa']){
          _africa = grouparr['Africa']
        }
        let total4 = that._.map(_africa, 'value')
        _africa.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Africa = {
          name: '非洲',
          value: total4.join('+'),
          itemStyle: {
            color: 'rgb(150, 79, 76)'
          },
          children: _africa
        }
        _currentlistdata.push(Africa)
      }
      if(grouparr['大洋洲'] || grouparr['Oceania']){
        let _oceania = []
        if(grouparr['大洋洲']){
          _oceania = grouparr['大洋洲']
        }
        if(grouparr['Oceania']){
          _oceania = grouparr['Oceania']
        }
        let total5 = that._.map(_oceania, 'value')
        _oceania.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Oceania = {
          name: '大洋洲',
          value: total5.join('+'),
          itemStyle: {
            color: 'rgb(0, 148, 115)'
          },
          children: _oceania
        }
        _currentlistdata.push(Oceania)
      }
      if(grouparr['拉丁美洲和加勒比'] || grouparr['Latin America & Caribbean']){
        let _regionunknown = []
        if(grouparr['拉丁美洲和加勒比']){
          _regionunknown = grouparr['拉丁美洲和加勒比']
        }
        if(grouparr['Latin America & Caribbean']){
          _regionunknown = grouparr['Latin America & Caribbean']
        }
        let total6 = that._.map(_regionunknown, 'value')
        _regionunknown.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let regionunknown = {
          name: '拉丁美洲和加勒比',
          value: total6.join('+'),
          itemStyle: {
            color: 'rgb(64, 158, 225)'
          },
          children: _regionunknown
        }
        _currentlistdata.push(regionunknown)
      }
      if(grouparr['undefined']){
        let _others = grouparr['undefined']
        let total6 = that._.map(_others, 'value')
        _others.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Others = {
          name: '其他',
          value: total6.join('+'),
          itemStyle: {
            color: 'rgb(132, 151, 176)'
          },
          children: _others
        }
        _currentlistdata.push(Others)
      }
      return _currentlistdata      
    },

    /**
     * 设置中国省份区域
     */
    setProvinceArea: function(res){
      let that = this
      let grouparr = that._.groupBy(res,'region')
      let _currentlistdata = []
      if(grouparr['东北'] || grouparr['Northeast China']){
        let _northeastchina = []
        if(grouparr['东北']){
          _northeastchina = grouparr['东北']
        }
        if(grouparr['Northeast China']){
          _northeastchina = grouparr['Northeast China']
        }
        let total1 = that._.map(_northeastchina, 'value')
        _northeastchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let NortheastChina = {
          name: '东北',
          value: total1.join('+'),
          itemStyle: {
            color: 'rgb(159, 79, 76)'
          },
          children: _northeastchina
        }
        _currentlistdata.push(NortheastChina)
      }
      if(grouparr['华北'] || grouparr['North China']){
        let _northchina = []
        if(grouparr['华北']){
          _northchina = grouparr['华北']
        }
        if(grouparr['North China']){
          _northchina = grouparr['North China']
        }
        let total2 = that._.map(_northchina, 'value')
        _northchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let NorthChina = {
          name: '华北',
          value: total2.join('+'),
          itemStyle: {
            color: 'rgb(190, 69, 116)'
          },
          children: _northchina
        }
        _currentlistdata.push(NorthChina)
      }
      if(grouparr['西北'] || grouparr['Northwest China']){
        let _northeastchina = []
        if(grouparr['西北']){
          _northeastchina = grouparr['西北']
        }
        if(grouparr['Northwest China']){
          _northeastchina = grouparr['Northwest China']
        }
        let total3 = that._.map(_northeastchina, 'value')
        _northeastchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let NortheastChina = {
          name: '西北',
          value: total3.join('+'),
          itemStyle: {
            color: 'rgb(0, 148, 115)'
          },
          children: _northeastchina
        }
        _currentlistdata.push(NortheastChina)
      }
      if(grouparr['西南'] || grouparr['Southwast China']){
        let _southwastchina = []
        if(grouparr['西南']){
          _southwastchina = grouparr['西南']
        }
        if(grouparr['Southwast China']){
          _southwastchina = grouparr['Southwast China']
        }
        let total4 = that._.map(_southwastchina, 'value')
        _southwastchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let NorthwastChina = {
          name: '西南',
          value: total4.join('+'),
          itemStyle: {
            color: 'rgb(51, 102, 153)'
          },
          children: _southwastchina
        }
        _currentlistdata.push(NorthwastChina)
      }
      if(grouparr['华中'] || grouparr['Central China']){
        let _centralchina = []
        if(grouparr['华中']){
          _centralchina = grouparr['华中']
        }
        if(grouparr['Central China']){
          _centralchina = grouparr['Central China']
        }
        let total5 = that._.map(_centralchina, 'value')
        _centralchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let CentralChina = {
          name: '华中',
          value: total5.join('+'),
          itemStyle: {
            color: 'rgb(64, 158, 255)'
          },
          children: _centralchina
        }
        _currentlistdata.push(CentralChina)
      }
      if(grouparr['华南'] || grouparr['South China']){
        let _souchina = []
        if(grouparr['华南']){
          _souchina = grouparr['华南']
        }
        if(grouparr['South China']){
          _souchina = grouparr['South China']
        }
        let total6 = that._.map(_souchina, 'value')
        _souchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let SouthChina = {
          name: '华南',
          value: total6.join('+'),
          itemStyle: {
            color: 'rgb(132, 151, 176)'
          },
          children: _souchina
        }
        _currentlistdata.push(SouthChina)
      }
      if(grouparr['华东'] || grouparr['East China']){
        let _eastchina = []
        if(grouparr['华东']){
          _eastchina = grouparr['华东']
        }
        if(grouparr['East China']){
          _eastchina = grouparr['East China']
        }
        let total7 = that._.map(_eastchina, 'value')
        _eastchina.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let EastChina = {
          name: '华东',
          value: total7.join('+'),
          itemStyle: {
            color: 'rgb(221, 65, 36)'
          },
          children: _eastchina
        }
        _currentlistdata.push(EastChina)
      }
      if(grouparr['undefined']){
        let _others = grouparr['undefined']
        let total8 = that._.map(_others, 'value')
        _others.forEach(e => {
          e.newunit = that.searchindex === 'volume' ? e.unit : that.searchunit2 === 'rmb' ? that.$t('charttxt.t6') : that.$t('charttxt.t5')
        })
        let Others = {
          name: '其他',
          value: total8.join('+'),
          itemStyle: {
            color: 'rgb(150, 79, 76)'
          },
          children: _others
        }
        _currentlistdata.push(Others)
      }
      return _currentlistdata
    },

  },

}
</script>

<style>
.el-scrollbar__bar.is-horizontal{
  height: 0px;
}
.el-scrollbar__wrap{
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>